import { sessionStore } from "../stores/session";
import { get } from "svelte/store";
import PATHS from "../constants/routePaths";
import { navigateToPath } from "../routing";

const getInitialFlowRoute = () => {
  const { routes } = get(sessionStore);
  const landingRouteIndex = routes.findIndex((route) => route.id === "landing");
  return routes[landingRouteIndex + 1];
};

export const retryRedirect = () => {
  const allowlist = get(sessionStore).stepAllowList;
  const redirectPath = allowlist.includes(PATHS.MENU) ? PATHS.MENU : getInitialFlowRoute()?.path;
  navigateToPath(redirectPath ?? PATHS.ROOT);
};
